import React, { useEffect, useState } from "react";
import axios from "axios";
import TemplateComp from "../contentReaderMarkdown/templateComp";
import LinkExpire from "../contentReaderMarkdown/linkExpire";
import CircleLoader from "../notes/component/CircleLoader";
function ViewSharedContent({ id, validation, url = "", code = null }) {
   const [content, setContent] = useState(null);
   const [error, setError] = useState(false);
   const [loader, setLoader] = useState(true);

   const fetchSignedUrl = () => {
      const postData = {
         id: id,
         // validation: validation,
         // event: "validation",
      };
      axios
         .post(`${process.env.REACT_APP_URL}/servercontent/${"validation"}`, postData)
         .then((response) => {
            const responseData = response.data;
            if (responseData.signedURL) {
               fetchData(responseData.signedURL);
            } else {
               setContent(responseData.note);
               setLoader(false);
            }
         })
         .catch(() => {
            setError(true);
            setLoader(false);
            setContent(null);
         });
   };

   useEffect(() => {
      fetchSignedUrl();
   }, []);

   const fetchData = async (urlToFetch) => {
      try {
         const response = await axios.get(urlToFetch);
         if (response?.data?.new) {
            setContent(response.data?.new);
         } else {
            setContent(response.data);
         }
         setLoader(false);
      } catch (error) {
         setError(true);
         setLoader(false);
         setContent(null);
      }
   };

   return (
      <div className="py-2 h-100">
         {loader ? (
            <div className=" h-90 flex-center">
               <CircleLoader />
            </div>
         ) : content ? (
            <TemplateComp content={content} />
         ) : null}
         {error && (
            <div className="link-expire-cont">
               <LinkExpire />
            </div>
         )}
      </div>
   );
}

export default ViewSharedContent;
